const state = {
  hands: [
    {
      cards: 'AA',
      type: 'p',
      combos: 6,
      markers: []
    },
    {
      cards: 'AKs',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'AQs',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'AJs',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'ATs',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'A9s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'A8s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'A7s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'A6s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'A5s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'A4s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'A3s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'A2s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'AKo',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'KK',
      type: 'p',
      combos: 6,
      markers: []
    },
    {
      cards: 'KQs',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'KJs',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'KTs',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'K9s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'K8s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'K7s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'K6s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'K5s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'K4s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'K3s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'K2s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'AQo',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'KQo',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'QQ',
      type: 'p',
      combos: 6,
      markers: []
    },
    {
      cards: 'QJs',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'QTs',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'Q9s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'Q8s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'Q7s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'Q6s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'Q5s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'Q4s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'Q3s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'Q2s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'AJo',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'KJo',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'QJo',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'JJ',
      type: 'p',
      combos: 6,
      markers: []
    },
    {
      cards: 'JTs',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'J9s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'J8s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'J7s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'J6s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'J5s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'J4s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'J3s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'J2s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'ATo',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'KTo',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'QTo',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'JTo',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'TT',
      type: 'p',
      combos: 6,
      markers: []
    },
    {
      cards: 'T9s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'T8s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'T7s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'T6s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'T5s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'T4s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'T3s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'T2s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'A9o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'K9o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'Q9o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'J9o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'T9o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '99',
      type: 'p',
      combos: 6,
      markers: []
    },
    {
      cards: '98s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: '97s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: '96s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: '95s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: '94s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: '93s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: '92s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'A8o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'K8o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'Q8o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'J8o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'T8o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '98o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '88',
      type: 'p',
      combos: 6,
      markers: []
    },
    {
      cards: '87s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: '86s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: '85s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: '84s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: '83s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: '82s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'A7o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'K7o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'Q7o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'J7o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'T7o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '97o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '87o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '77',
      type: 'p',
      combos: 6,
      markers: []
    },
    {
      cards: '76s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: '75s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: '74s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: '73s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: '72s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'A6o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'K6o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'Q6o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'J6o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'T6o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '96o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '86o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '76o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '66',
      type: 'p',
      combos: 6,
      markers: []
    },
    {
      cards: '65s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: '64s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: '63s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: '62s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'A5o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'K5o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'Q5o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'J5o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'T5o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '95o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '85o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '75o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '65o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '55',
      type: 'p',
      combos: 6,
      markers: []
    },
    {
      cards: '54s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: '53s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: '52s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'A4o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'K4o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'Q4o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'J4o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'T4o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '94o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '84o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '74o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '64o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '54o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '44',
      type: 'p',
      combos: 6,
      markers: []
    },
    {
      cards: '43s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: '42s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'A3o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'K3o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'Q3o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'J3o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'T3o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '93o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '83o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '73o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '63o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '53o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '43o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '33',
      type: 'p',
      combos: 6,
      markers: []
    },
    {
      cards: '32s',
      type: 's',
      combos: 4,
      markers: []
    },
    {
      cards: 'A2o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'K2o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'Q2o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'J2o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: 'T2o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '92o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '82o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '72o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '62o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '52o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '42o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '32o',
      type: 'o',
      combos: 12,
      markers: []
    },
    {
      cards: '22',
      type: 'p',
      combos: 6,
      markers: []
    }
  ]
}

const getters = {
  hands: (state) => state.hands
}

const namespaced = true

export default {
  namespaced,
  state,
  getters
}
